import { render, staticRenderFns } from "./proposalDialog.vue?vue&type=template&id=60582e74&scoped=true"
import script from "./proposalDialog.vue?vue&type=script&lang=js"
export * from "./proposalDialog.vue?vue&type=script&lang=js"
import style0 from "./proposalDialog.vue?vue&type=style&index=0&id=60582e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60582e74",
  null
  
)

export default component.exports